import React from 'react';

import cookie from 'react-cookies';
import PropTypes from 'prop-types';
import connect from 'react-redux/lib/connect/connect';

import * as ReportDucks from 'ducks/reports/report';
import * as RouteDucks from 'ducks/routes';

import SectionLoaderAtom from 'atoms/SectionLoader';
import PaginationComponent from 'components/common/Pagination';
import EmployeeDailyTimecardTableComponent from 'components/reports/employeeDailyTimecard/Table';

import { PAGE_COUNT } from 'constants/records';

/**
 * ReportDetailPage -> EmployeeDailyimecardListSection
 *
 * Components:
 *    - {@link EmployeeDailyTimecardTableComponent}
 *    - {@link PaginationComponent}
 *
 * State:
 *    - reportData
 *
 * Actions:
 *    None
 */
const EmployeeDailyimecardListSection = (props) => {
  const { data, isLoading, location, reportDetail } = props;
  const {query} = location;
  const cookieData = cookie.load("employee_daily_timecard_page_size");
  let pageSize;

  if(cookieData) pageSize = +cookieData;
  else if (query && query.page_size)  pageSize = +query.page_size;
  else pageSize = 10;

  if (isLoading) return <SectionLoaderAtom active />;
  return (
    <section>
      <EmployeeDailyTimecardTableComponent
        data={data}
        location={location}
        child={reportDetail.parent_report}
        pageSize={pageSize}
      />
      <PaginationComponent
        count={data.length}
        location={location}
        pageCount={PAGE_COUNT}
        cookieKey="employee_daily_timecard_page_size"
      />
    </section>
  );
};

const mapStateToProps = state => ({
  data: ReportDucks.reportData(state),
  reportDetail: ReportDucks.reportDetail(state), 
  location: RouteDucks.location(state),
});

const mapActionsToProps = dispatch => ({});

EmployeeDailyimecardListSection.propTypes = {
  data: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
};

EmployeeDailyimecardListSection.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapActionsToProps,
)(EmployeeDailyimecardListSection);
